<template>
  <div>
    <el-dialog
      title="支付宝自动转账配置"
      class="autotransfer-dialog"
      width="600px"
      :append-to-body="true"
      :modal-append-to-body="false"
      v-on="$listeners"
      v-bind="$attrs"
      @close="handleClose"
    >
      <div class="desc">
        <span class="desc-text">配置支付宝自动转账功能，一键发放会员提现，免去手动打款的繁琐操作。</span>
        <app-link class="desc-link" to="https://www.zhutui.cn/help#/helpCenter/307/60">如何签约授权</app-link>
      </div>

      <div class="function">
        <el-row
          class="function-item"
          type="flex"
          justify="space-between"
          align="middle"
        >
          <el-col>
            <span class="title">1. 功能授权</span>
          </el-col>
          <el-col>
            <el-row type="flex" justify="end">
              <zt-button
                :type="autoTransferStatus.isAlipayAuth ? 'primary' : 'orange'"
                @click="handleAuth"

                :loading="authLoading"
              >{{ autoTransferStatus.isAlipayAuth ? "已授权" : "去授权" }}</zt-button>
            </el-row>
            <el-row type="flex" justify="end" class="help">
              *请使用发放款项的支付宝账号进行授权。
            </el-row>
          </el-col>
        </el-row>

        <el-row
          class="function-item"
          type="flex"
          justify="space-between"
          align="middle"
        >
          <el-col>
            <span class="title">2. 功能签约</span>
          </el-col>
          <el-col>
            <el-row type="flex" justify="end">
              <zt-button
                v-if="autoTransferStatus.signStatus === signStatusMap['已签约']"
                type="primary"
                @click="handleSign"
              >已签约</zt-button>
              <zt-button
                v-else-if="['审核中', '待商户确认协议'].includes(signStatusMap[autoTransferStatus.signStatus])"
                type="info"
                disabled
                :loading="signLoading"
              >{{ signStatusMap[autoTransferStatus.signStatus] }}</zt-button>
              <zt-button v-else type="orange" @click="handleSign">去签约</zt-button>
            </el-row>
            <el-row type="flex" justify="end" class="help">
              *签约账号请与授权账号保持一致。
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import taoke_check_ali_sign_up from '@/api/taoke_check_ali_sign_up';
import { signStatusMap } from '../withdraw.const.js'
import alipayAuth from './alipayAuth'
import Vue from 'vue'
export default Vue.extend({
  props: {
    autoTransferStatus: Object,
  },
  data: () => ({
    // 签约状态
    signStatusMap,

    signLoading: false,
    authLoading: false,
  }),
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 处理授权
    async handleAuth() {
      if(this.autoTransferStatus.isAlipayAuth) {
        this.$alert('账号授权已完成，需要修改请联系客服<br />QQ：1814846507', '提示', {
          type: 'success',
          dangerouslyUseHTMLString: true,
        })
        return
      }
      this.authLoading = true
      await alipayAuth().finally(() => {
        this.authLoading = false
      })
    },
    // 处理签约
    async handleSign() {


      // 已签约
      if(this.autoTransferStatus.isAlipaySign) {
        this.$alert('账号签约已完成，需要修改请联系客服<br />QQ：1814846507', '提示', {
          type: 'success',
          dangerouslyUseHTMLString: true,
        })
        return
      }

      const actionTip = await this.$confirm('签约后不可更改，需要更改得联系客服。', '注意', {
        type: 'warning',
      })
      if(actionTip !== 'confirm') return

      // const windowOpen = window.open()
      this.signLoading = true
      const { data } = await taoke_check_ali_sign_up().finally(() => {
        this.signLoading = false
      })
      if(data.error_code !== 0) {
        this.$message.error(data.error_message)
        // windowOpen.close()
        return
      }


      const a = document.createElement('a')
      a.target = '_blank'
      a.href = data.sign_url
      document.body.append(a)
      a.click()
      a.remove()

      // windowOpen.location.href = data.sign_url
      await this.$confirm( '是否已完成签约？', '提示', {
        type: 'warning',
        cancelButtonText: '未签约',
        confirmButtonText: '已签约',
        closeOnClickModal: false,
      })
      this.getAutoTransferStatus()
      this.$emit('refresh-status')
    },
  },
})
</script>

<style lang="scss" scoped>
.autotransfer-dialog {
  .desc {
    position: relative;
    padding-bottom: 24px;
    .desc-text {
      color: $theme-textsecond;
    }
    .desc-link {
      color: $theme;
      text-decoration: underline;
    }
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: $theme-border1;
    }
  }
  .function {
    padding: 32px 0;
    .function-item {
      +.function-item {
        margin-top: 26px;
      }
      .title {
        float: left;
        font-size: 18px;
        font-weight: bold;
        color: $theme-textmain;
      }
      .help {
        margin-top: 12px;
        font-size: 12px;
        color: $theme-textsecond;
      }
    }
  }

}
</style>
